class Logger {
  trace(...data) {
    process.env.NODE_ENV !== "production" && console.trace(...data);
  }
  debug(...data) {
    process.env.NODE_ENV !== "production" && console.debug(...data);
  }
  info(...data) {
    process.env.NODE_ENV !== "production" && console.info(...data);
  }
  warn(...data) {
    process.env.NODE_ENV !== "production" && console.warn(...data);
  }
  error(...data) {
    process.env.NODE_ENV !== "production" && console.error(...data);
  }
}

export default new Logger();
